// Stripe.js (embedded card entry). PCI SAQ-A: the script MUST load from Stripe's
// origin at runtime — never bundled, never mirrored (ADR-010).
export const STRIPE_JS_SRC = 'https://js.stripe.com/v3/';

/** Stripe `card.brand` ids → customer-facing labels. Unknown ids fall back to 'Card'. */
export const STRIPE_CARD_BRAND_LABELS: Record<string, string> = {
  visa: 'Visa',
  mastercard: 'Mastercard',
  amex: 'American Express',
  discover: 'Discover',
  diners: 'Diners Club',
  jcb: 'JCB',
  unionpay: 'UnionPay',
} as const;

export const STRIPE_CARD_BRAND_FALLBACK_LABEL = 'Card';
